import { BroadcastTipTapReadonlyView } from "../BroadcastTipTapReadonlyView";
import { useBroadcastPreviewContent } from "./useBroadcastPreviewContent";

export const TiptapBuilderPreviewContent = () => {
  const { emailContent, isLoading } = useBroadcastPreviewContent();

  if (isLoading || !emailContent) {
    return null;
  }

  return <BroadcastTipTapReadonlyView content={emailContent} />;
};
